import React from 'react';
import styled from 'styled-components';

import { Text } from '../atom/Text';
import { Padding } from '../atom/Padding';
import { Flex } from '../atom/Layout';

import { ReactComponent as Select } from '../../../lib/image/icons/selecct.svg';
import { ReactComponent as UnSelect } from '../../../lib/image/icons/noselect.svg';

export const InputRadioList = ({
  radioData = [
    {
      label: '',
      value: '',
      checked: undefined,
      onChange: undefined,
      disabled: false,
    },
  ],
}) => {
  return radioData.map((data) => (
    <RadioLabel key={data.label} marginLeft="1.375rem">
      {data.checked ? <Select /> : <UnSelect />}
      <input
        type="radio"
        name="radio"
        value={data.value}
        checked={data.checked}
        onChange={data.onChange}
        style={{ display: 'none' }}
        disabled={data.disabled}
      />
      <Text weight="medium" size={12} style={{ marginLeft: '0.75rem' }}>
        {data.label}
      </Text>
    </RadioLabel>
  ));
};

export const VerticalInputRadioList = ({
  radioData = [
    {
      label: '',
      value: '',
    },
  ],
  checked = undefined,
  onChange = undefined,
}) => {
  return radioData.map((data) => (
    <RadioLabel key={data.label} padding="0.625rem 0">
      {checked === data.label ? <Select /> : <UnSelect />}
      <input
        type="radio"
        name="radio"
        value={data.value}
        checked={checked === data.label}
        onChange={onChange}
        style={{ display: 'none', lineHeight: '1.29' }}
      />
      <Text weight="medium" size={14} style={{ margin: '0.1rem 0 0 0.625rem' }}>
        {data.label}
      </Text>
    </RadioLabel>
  ));
};

export const VerticalImageInputRadioList = ({
  radioData = [
    {
      id: 0,
      src: '',
      checked: undefined,
      onChange: undefined,
      disabled: false,
    },
  ],
}) => {
  return Array(Math.ceil(radioData.length / 5))
    .fill(0)
    .map((_, idx) => (
      <Flex justifyContent="flex-start" key={idx}>
        {radioData.slice(idx * 5, idx * 5 + 5).map((data) => (
          <RadioLabel key={data.id} column marginLeft="0.563rem">
            <Image src={data.src} active={data.checked} />
            <input
              type="radio"
              name="radio"
              checked={data.checked}
              onChange={data.onChange}
              style={{ display: 'none' }}
              disabled={data.disabled}
            />
            <Padding top="7" bottom="10">
              {data.checked ? <Select /> : <UnSelect />}
            </Padding>
          </RadioLabel>
        ))}
      </Flex>
    ));
};

const RadioLabel = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: ${(props) => (props.column ? 'column' : 'row')};
  padding: ${(props) => props.padding || 0};
  cursor: pointer;

  & + & {
    margin-left: ${(props) => props.marginLeft};
  }
`;

const Image = styled.img`
  width: 3.75rem;
  height: 3.75rem;
  background: ${(props) => props.theme.background.white};
  border: ${(props) =>
    props.active
      ? `solid 2px ${props.theme.color.orangePink}`
      : `solid 1px ${props.theme.color.pinkishGrey}`};
`;
